import { AuthLogin, AuthLogout, AuthUpdate, AuthForgot, AuthRegist, AuthReset } from '@/components/Auth';

export default [
  {
    path: '/auth/login',
    component: AuthLogin,
    meta: {
      text: 'ログイン',
      level: 0,
    },
  },
  {
    path: '/auth/logout',
    component: AuthLogout,
    meta: {
      text: 'ログアウト',
      level: 0,
    },
  },
  {
    path: '/auth/update',
    component: AuthUpdate,
    meta: {
      text: 'パスワード変更',
    },
  },
  {
    path: '/auth/forgot',
    component: AuthForgot,
    meta: {
      text: 'パスワード忘れ',
      level: 0,
    },
  },
  {
    path: '/auth/regist/:email/:code',
    component: AuthRegist,
    meta: {
      text: 'パスワード登録',
      level: 0,
    },
  },
  {
    path: '/auth/reset/:email/:code',
    component: AuthReset,
    meta: {
      text: 'パスワード再発行',
      level: 0,
    },
  },
];
